import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { Image as d } from "../Image/index.js";
import { BestPriceBadge as p } from "../BestPriceBadge/index.js";
import { getFormattedPrice as h } from "../../services/strings/index.js";
import { Container as f, Header as g, StoreWrapper as P, Info as I, Price as u, ProductImage as x } from "./style.js";
const y = ({
  image: n,
  title: o,
  price: t,
  store: i,
  storeImage: a,
  isBestPrice: c = !1,
  ...s
}) => {
  const [m, l] = h(t).split(",");
  return /* @__PURE__ */ r(f, { ...s, children: [
    /* @__PURE__ */ r(g, { children: [
      /* @__PURE__ */ r(P, { children: [
        /* @__PURE__ */ e(d, { src: a, role: "presentation" }),
        /* @__PURE__ */ e("span", { children: i })
      ] }),
      c && /* @__PURE__ */ e(p, {})
    ] }),
    /* @__PURE__ */ r(I, { children: [
      /* @__PURE__ */ e("p", { children: o }),
      /* @__PURE__ */ r(u, { children: [
        "R$ ",
        /* @__PURE__ */ e("span", { className: "value", children: m }),
        /* @__PURE__ */ r("span", { children: [
          ",",
          l
        ] })
      ] })
    ] }),
    /* @__PURE__ */ e(x, { src: n, role: "presentation" })
  ] });
};
export {
  y as SlimSecondaryDealCard
};
